export const gray = '#aaaaaa';
